// Vuexストア - ナビゲーションバーモジュール
export default {
  namespaced: true,
  
  state: {
    isScrolled: false,
    scrollPosition: 0,
    isMobileMenuOpen: false,
    activeDropdownId: null,
    theme: 'light',
    navigationItems: [
      {
        id: 'tokutyou',
        label: 'top.tokutyou.title',
        href: '#tokutyou',
        isExternal: false,
        mobileOnly: false
      },
      {
        id: 'features',
        label: 'top.features.title',
        href: '#features',
        isExternal: false,
        mobileOnly: false
      },
      {
        id: 'security',
        label: 'セキュリティについて知る',
        path: '/about/security',
        isExternal: false,
        mobileOnly: true
      },
      {
        id: 'dashboard-info',
        label: 'ファイル管理について知る',
        path: '/about/dashboard',
        isExternal: false,
        mobileOnly: true
      },
      {
        id: 'subscription',
        label: 'subscription.title',
        path: '/subscription',
        isExternal: false,
        mobileOnly: false
      },
      {
        id: 'faq',
        label: 'faq.title',
        path: '/faq',
        isExternal: false,
        mobileOnly: false
      }
    ],
    mobileMenuTransitionDuration: 300,
    dropdownTransitionDuration: 200
  },
  
  getters: {
    // 現在のスクロール状態を取得
    isScrolled: state => state.isScrolled,
    
    // スクロール位置を取得
    scrollPosition: state => state.scrollPosition,
    
    // モバイルメニューの開閉状態を取得
    isMobileMenuOpen: state => state.isMobileMenuOpen,
    
    // アクティブなドロップダウンIDを取得
    activeDropdownId: state => state.activeDropdownId,
    
    // PC用のナビゲーション項目を取得
    desktopNavigationItems: state => {
      return state.navigationItems.filter(item => !item.mobileOnly)
    },
    
    // モバイル用のナビゲーション項目を取得
    mobileNavigationItems: state => {
      return state.navigationItems
    },
    
    // プレミアム項目を取得
    premiumNavigationItems: state => {
      return state.navigationItems.filter(item => item.isPremium)
    },
    
    // 特定のドロップダウンがアクティブかを判定
    isDropdownActive: state => dropdownId => {
      return state.activeDropdownId === dropdownId
    }
  },
  
  mutations: {
    // スクロール状態を設定
    SET_SCROLL_STATE(state, { isScrolled, scrollPosition }) {
      state.isScrolled = isScrolled
      state.scrollPosition = scrollPosition
    },
    
    // モバイルメニューの状態を設定
    SET_MOBILE_MENU_STATE(state, isOpen) {
      state.isMobileMenuOpen = isOpen
    },
    
    // モバイルメニューを切り替え
    TOGGLE_MOBILE_MENU(state) {
      state.isMobileMenuOpen = !state.isMobileMenuOpen
    },
    
    // アクティブなドロップダウンを設定
    SET_ACTIVE_DROPDOWN(state, dropdownId) {
      state.activeDropdownId = dropdownId
    },
    
    // ドロップダウンを切り替え
    TOGGLE_DROPDOWN(state, dropdownId) {
      if (state.activeDropdownId === dropdownId) {
        state.activeDropdownId = null
      } else {
        state.activeDropdownId = dropdownId
      }
    },
    
    // すべてのドロップダウンを閉じる
    CLOSE_ALL_DROPDOWNS(state) {
      state.activeDropdownId = null
    },
    
    // ナビゲーション項目を追加
    ADD_NAVIGATION_ITEM(state, item) {
      state.navigationItems.push(item)
    },
    
    // ナビゲーション項目を削除
    REMOVE_NAVIGATION_ITEM(state, itemId) {
      state.navigationItems = state.navigationItems.filter(item => item.id !== itemId)
    },
    
    // ナビゲーション項目を更新
    UPDATE_NAVIGATION_ITEM(state, { itemId, updates }) {
      const index = state.navigationItems.findIndex(item => item.id === itemId)
      if (index !== -1) {
        state.navigationItems[index] = {
          ...state.navigationItems[index],
          ...updates
        }
      }
    },
    
    // テーマを設定
    SET_THEME(state, theme) {
      state.theme = theme
    }
  },
  
  actions: {
    // スクロール状態を更新
    updateScrollState({ commit }, scrollData) {
      commit('SET_SCROLL_STATE', scrollData)
    },
    
    // モバイルメニューを開く
    openMobileMenu({ commit }) {
      commit('SET_MOBILE_MENU_STATE', true)
      // body要素のスクロールをロック
      document.body.style.overflow = 'hidden'
    },
    
    // モバイルメニューを閉じる
    closeMobileMenu({ commit }) {
      commit('SET_MOBILE_MENU_STATE', false)
      // body要素のスクロールロックを解除
      document.body.style.overflow = ''
    },
    
    // モバイルメニューを切り替え
    toggleMobileMenu({ commit, state }) {
      commit('TOGGLE_MOBILE_MENU')
      // body要素のスクロールを制御
      if (!state.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    
    // ドロップダウンを開く
    openDropdown({ commit }, dropdownId) {
      commit('SET_ACTIVE_DROPDOWN', dropdownId)
    },
    
    // ドロップダウンを閉じる
    closeDropdown({ commit }, dropdownId) {
      commit('SET_ACTIVE_DROPDOWN', null)
    },
    
    // ドロップダウンを切り替え
    toggleDropdown({ commit }, dropdownId) {
      commit('TOGGLE_DROPDOWN', dropdownId)
    },
    
    // すべてのメニューを閉じる
    closeAllMenus({ commit }) {
      commit('SET_MOBILE_MENU_STATE', false)
      commit('CLOSE_ALL_DROPDOWNS')
      document.body.style.overflow = ''
    },
    
    // ナビゲーション項目を動的に追加
    addNavigationItem({ commit }, item) {
      // 必須フィールドの検証
      if (!item.id || !item.label) {
        console.error('Navigation item must have id and label')
        return
      }
      
      // デフォルト値を設定
      const navigationItem = {
        isExternal: false,
        mobileOnly: false,
        isPremium: false,
        ...item
      }
      
      commit('ADD_NAVIGATION_ITEM', navigationItem)
    },
    
    // ナビゲーション項目を削除
    removeNavigationItem({ commit }, itemId) {
      commit('REMOVE_NAVIGATION_ITEM', itemId)
    },
    
    // ナビゲーション項目を更新
    updateNavigationItem({ commit }, { itemId, updates }) {
      commit('UPDATE_NAVIGATION_ITEM', { itemId, updates })
    },
    
    // テーマを変更
    changeTheme({ commit }, theme) {
      commit('SET_THEME', theme)
    }
  }
}